__turbopack_context__.v({
  "carousel": "ResultsCarousel-module-scss-module__nFtNvq__carousel",
  "controls": "ResultsCarousel-module-scss-module__nFtNvq__controls",
  "navButton": "ResultsCarousel-module-scss-module__nFtNvq__navButton",
  "navButtons": "ResultsCarousel-module-scss-module__nFtNvq__navButtons",
  "navIcon": "ResultsCarousel-module-scss-module__nFtNvq__navIcon",
  "nextIcon": "ResultsCarousel-module-scss-module__nFtNvq__nextIcon",
  "prevIcon": "ResultsCarousel-module-scss-module__nFtNvq__prevIcon",
  "progress": "ResultsCarousel-module-scss-module__nFtNvq__progress",
  "progressDot": "ResultsCarousel-module-scss-module__nFtNvq__progressDot",
  "progressDotActive": "ResultsCarousel-module-scss-module__nFtNvq__progressDotActive",
  "slide": "ResultsCarousel-module-scss-module__nFtNvq__slide",
  "viewport": "ResultsCarousel-module-scss-module__nFtNvq__viewport",
});
